import React from 'react';
import { Loader, Settings } from 'lucide-react';

const getProjectImageUrl = (project, ftps3ImageUrls) => {
  return ftps3ImageUrls[project.id] || null;
};


const ProjectLastFrameImage = ({
  project,
  ftps3ImageUrls,
  imageLoadingStates,
  imageErrorStates,
  imageOrientations,
  handleImageLoad,
  handleImageError,
  handleIngresar
}) => {
  //console.log(`[PLFI - Render]   imageLoadingStates[${project.id}]: ${imageLoadingStates[project.id]}`);
  //console.log(`[PLFI - Render]   imageErrorStates[${project.id}]: ${imageErrorStates[project.id]}`);
  //console.log(`[PLFI - Render]   ftps3ImageUrls[${project.id}]: ${ftps3ImageUrls[project.id]}`);


  const imageUrl = getProjectImageUrl(project, ftps3ImageUrls);

  if (!project?.feedID || project?.feedID === 'null') {
    //console.log(`[PLFI - Render] Project ${project.id}: No feedID, showing config message.`);
    return (
      <div className="flex flex-col items-center justify-center h-full text-center px-4 py-6 text-gray-600 bg-white rounded-md">
        <p className="text-sm font-medium">
          Configure su cámara en el botón <Settings size={16} className="inline mx-1" />
        </p>
        <p className="text-sm font-medium">
          Luego aguarde la aprobación del técnico.
        </p>
      </div>
    );
  }

  return (
    <>
      {imageLoadingStates[project.id] && (
        <div className="image-loader-container">
          <Loader size={36} className="animate-spin text-gray-400" />
        </div>
      )}

      {imageUrl && (
        <img
          key={imageUrl}
          src={imageUrl}
          alt=""
          className="project-preview-img"
          onLoad={(e) => handleImageLoad(e, project.id)}
          onError={() => handleImageError(project.id, project)}
          onClick={() => handleIngresar(project.identifier)}
          style={{
            ...(imageOrientations[project.id]?.style || {}),
            display: imageLoadingStates[project.id] ? 'none' : 'block'
          }}
        />
      )}

      {!imageUrl && !imageLoadingStates[project.id] && (
        <div className="w-full h-full bg-white rounded-md" />
      )}
    </>
  );
};

export default ProjectLastFrameImage;
